export default async (context:any, payload:any) => {
    const sourceState = context.rootState[payload.sourceId];
    const params = sourceState.pathParams;

    const apiLocation = payload.oneLni.environment.current.apiLocation2;
    let endpoint = `${apiLocation}/janitorial-workload`;
    Object.keys(params).forEach(key => {
        if (params[key]) {
            endpoint = `${endpoint}/${key}/${params[key]}`;
        }
    });
    try {
        const response = await fetch(endpoint, {
            mode: 'cors',
        });
        const json = await response.json();

        const results = json.results;
        context.commit('appState/SET_VALUE', {
            key: 'data',
            value: results,
        }, {
            root: true,
        });
        return results;
    } catch {
        // TODO: Error handling
        return null;
    }
};